import { Button } from "components/LEGACY/styled-components/Buttons"
import { Card, CardBody, CardHeader, CardTitle } from "components/LEGACY/styled-components/Cards"
import { ResponsiveHalfColumn } from "components/LEGACY/styled-components/Flex"
import { Table, TableBody, TableFooter, TableHeader, Th, Tr } from "components/LEGACY/styled-components/Table"
import Loader from "components/utils/Loader"
import { sendEmailVerification } from "firebase/auth"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { useCurrentUser } from "hooks/localstate/auth/useCurrentUser"
import Link from "next/link"
import { useState } from "react"
import Shop from "types/firestore/shop"
import RestaurantTableItem from "./RestaurantTableItem"

const RestaurantTable = ({ shops }: { shops: WithRef<Shop>[] }) => {
  const currentUser = useCurrentUser()
  const [emailLoading, setEmailLoading] = useState(false)
  return currentUser?.emailVerified ? (
    <Card margin="0 0 0 0" overflowY="auto">
      <CardHeader justifyContent="space-between">
        <CardTitle>Meine Betriebe</CardTitle>
        <Link href="/admin/new-shop" passHref>
          <Button>Betrieb hinzufügen</Button>
        </Link>
      </CardHeader>

      <Table>
        <TableHeader>
          <Tr>
            <Th width="20px">#</Th>
            <Th width="50%">Betrieb</Th>
            <Th>Ort</Th>
            <Th></Th>
          </Tr>
        </TableHeader>
        <TableBody>
          {shops.map((shop, index) => {
            return <RestaurantTableItem shop={shop} index={index} key={shop._ref.id} />
          })}
        </TableBody>
        <TableFooter />
      </Table>
    </Card>
  ) : (
    <ResponsiveHalfColumn>
      <Card>
        <CardBody>
          <h1>Willkommen bei getpacked!</h1>

          <p>Bitte Bestätige Deine E-Mail über den Link, den wir dir gerade zugesendet haben, um loszulegen.</p>
          <p>Wenn Du Deine E-Mail bereits bestätigt hast, lade diese Seite neu.</p>
          <p>E-Mail nicht bekommen?</p>

          <Button
            onClick={() => {
              if (!currentUser) return
              setEmailLoading(true)
              sendEmailVerification(currentUser).then(() => {
                setEmailLoading(false)
              })
            }}
            success
            disabled={emailLoading || !currentUser}
          >
            {emailLoading ? <Loader style={{ height: "1rem", width: "1rem" }} /> : "E-Mail erneut senden"}
          </Button>
        </CardBody>
      </Card>
    </ResponsiveHalfColumn>
  )
}

export default RestaurantTable
